import { generateAudio } from '../components/audiosSDK';
import { callOutStateToModel } from '../mappers/models.mapper';
import { STRATEGIES_ALERTS } from './Strategies_Alerts_And_Errors';
import { triggerNotifications } from '../Helpers/helperMessages';
import { LIST_STATES, SHOW_TRANSFERS_BUTTONS, TYPE_CALL, VALIDATING_TELEPHONY, STATE_TO_PLAY_END_AUDIO, MESSAGE_CODES_AUDIOS, MESSAGE_CODES_ALERT} from '../constants/constants';
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from '../constants/Notifications';
import { Singleton } from '../Singletons/Singleton';

const language = new Singleton();
export const STRATEGIES_STATES = {
    "Login": (message, that) => {
        let myStorage = window.localStorage;
        myStorage.setItem('AgentTimeSpam', that.sharedData.getUserData().Login + "|" + that.agentController.getTimeStamp());
        that.svrEvents.onChangeStatus(message);
    },
    "logout": function (message, that) { 
        that.logout(); 
        that.svrEvents.onChangeStatus(message);
    },
    "firstCall": function (message, that, renderTag) {
        that.parametersEngine();
        that.agentController.conectSip(that.state.userLogin, renderTag);
        that.telephonyTime = message.WaitingTime;
        that.svrEvents.onValidatingTelephony({
            telephonyState:VALIDATING_TELEPHONY.SOURCE_MICRO,
            status: 0,
        });
        that.actionsValitatingTelephony();
        that.svrEvents.onChangeStatus(message);
    },
    "OnValidatedTelephony": function (message, that) {
        that.sharedData.setLogged(true);
        that.agentController.reconnectMic();
        if(that.sharedData.getLogged()){
            generateAudio(that, 'welcome');
        }
        that.svrEvents.onValidatingTelephony({
            telephonyState:VALIDATING_TELEPHONY.VALID,
            status:2,
        });
        that.svrEvents.onChangeStatus(message);
    },
    "Other": function (message, that) { 
        that.checkOtherState();
        that.svrEvents.onChangeStatus(message);
        const toolsTransfer = that.sharedData.getToolsTransfer();
        that.sharedData.isShowToolsTransfersActive = toolsTransfer.showOptionsOnTransfer;
        
        if(that.sharedData.isCallTypeInbound){
            that.sharedData.setLastCallDataInbound();
        }else{
            that.sharedData.setLastCallDataOutbound();
        }
        that.sharedData.isCallTypeInbound = false;
    },
    "Ready": function (message, that) {
        that.sharedData.setIsHangedUpByAgent(STATE_TO_PLAY_END_AUDIO.HANG_UP_CLIENT);
        if(that.sharedData.isBlindTranferActive){
            that.sharedData.isBlindTranferActive = false;
            const blindSuccess = language.getText('CallControlGUICallTransferBlindXferSuccess');
            triggerNotifications(that, MESSAGE_CODE.BLIND_TRANSFER[10402], MESSAGE_TYPE.INFO, MESSAGE_FROM.CW, blindSuccess);
        }
        that.sharedData.setIsRated(false);
        that.callId = 0;
        that.agentController.hangUp();
        that.svrEvents.onChangeStatus(message);
    },
    "ReadyPreviewPro": function (message, that) {
        that.sharedData.setIsRated(false);
        that.callId = 0;
        that.agentController.hangUp();
        that.svrEvents.onChangeStatus(message);
    },
    "Xfer": function (message, that) {
        let messageXfer = {
            currentState: LIST_STATES.XFER,
            action: "state"
        }
        that.svrEvents.onChangeStatus(messageXfer);
        that.sharedData.setAudioNotificationCallStart(null);
        that.sharedData.setAudioNotificationCallEnd(null);
        if(message.AudioStart){
            that.sharedData.setAudioNotificationCallStart(`https://${that.sharedData.getDomain()}/GalateaAdminWS/MsgAgentAutomatic/${message.AudioStart}`);
        }
        if(message.AudioEnd){
            that.sharedData.setAudioNotificationCallEnd(`https://${that.sharedData.getDomain()}/GalateaAdminWS/MsgAgentAutomatic/${message.AudioEnd}`);
        }
    },
    "Dialog": function (message, that) {
        generateAudio(that, 'dialog');
        that.svrEvents.onChangeStatus(message);
    },
    "Ringing": function (message, that) { 
        that.svrEvents.onChangeStatus(message);
        const audioToPlay = that.sharedData.getAudioNotificationCallStart();
        if(audioToPlay){
            const audio = new Audio(audioToPlay);
            audio.play();
        }
     },
     "NotReady": function (message, that) {
        console.log('[AgentSDK] [setUnavailables] [ResponseFromServer]: Status changed.');
        that.state.requiredAdminPass = message.requieredPassAdmin;
        that.state.setByAdmin = message.setByAdmin;
        that.state.sendRWPAction = 0;
        if(message.setByAdmin){
            console.log('Unavailable setted by Administrator.');
        }
        if(message.requieredPassAdmin){
            console.log('Unavailable Id: '+message.notReadyId+', Unavailable description: '+message.description+', Set by Admin: '+message.setByAdmin);
            console.warn('This unavailable status REQUIRES administrator password.');
        }else{
            console.log('Unavailable Id: '+message.notReadyId+', Unavailable description: '+message.description+', Set by Admin: '+message.setByAdmin);
            console.info('This unavailable status does not require an administrator password.');
        }
        that.svrEvents.onChangeStatus(message);
    },
    "Callout": function (message, that) {
        that.callId = message.CallId;
        that.callOutId = message.CallOutId;
        that.camId = message.CamId;
        that.phoneNumber = message.PhoneNumber;
        that.callType = TYPE_CALL.OUTBOUND;
        that.sharedData.setManualCallTime(message.CalloutMaxTime);
        that.svrEvents.onChangeStatus(callOutStateToModel(message));
        that.sharedData.isManualCallScheduled = false;
    },
    "ALERT": function(message, that) {
        switch (message.Code) {
            case MESSAGE_CODES_ALERT.BUSY: 
                generateAudio(that, MESSAGE_CODES_AUDIOS.BUSY);
                break;
            case MESSAGE_CODES_AUDIOS.FAX:
                generateAudio(that, MESSAGE_CODES_AUDIOS.FAX);
                break;
            default:
                break;
        };
        const alert = STRATEGIES_ALERTS[message.Module](message, that);
        that.svrEvents.onDialResult(alert);
        if(alert.idDialResult === 0 && message.Code !== '1511'){
            that.sharedData.isManualCallScheduled = true;
            triggerNotifications(that, MESSAGE_CODE.MANUAL_CALL[10902], MESSAGE_TYPE.INFO, MESSAGE_FROM.SDK);
        }
    },
    "Wrapup": function (message, that) {
        if(that.sharedData.isBlindTranferActive){
            that.sharedData.isBlindTranferActive = false;
            const blindSuccess = language.getText('CallControlGUICallTransferBlindXferSuccess');
            triggerNotifications(that, MESSAGE_CODE.BLIND_TRANSFER[10402], MESSAGE_TYPE.INFO, MESSAGE_FROM.CW, blindSuccess);
        }
        if(that.sharedCallOutData.saveDispositionInDialog === true && that.sharedData.currentState !== LIST_STATES.NOTREADY){
            that.setReady();
        } else {
            let time = 0;
            if(that.sharedData.currentState === LIST_STATES.CALLOUT){
                time = parseInt(message.WrapUpTime)
            }
            else if(that.sharedData.currentState === LIST_STATES.DIALOG){
                time = parseInt(that.sharedCallOutData.wrapUpTime);
            }
            
            if(time === 0){
                console.info("[AgentSDK] [Info]: Wrapup time in campaign is "+time+", starting indefinite time.")
                timeWrapup(that, 604800);
            } else if(time > 0 ){
                timeWrapup(that, time);
            }
        }
        if(message.WrapUpTime){
            const currentCamId = message.CamId ? message.CamId : that.camId;
            const currentFrame = that.sharedData.callOutCampaigns.find(camp => camp.camdId === currentCamId);
            
            let newMessageWrapup ={
                callId: that.callId ? that.callId : message.CallId,
                wrapUpTime: message.WrapUpTime,
                callKey: message.CallKey,
                callOutId: message.CallOutId,
                callType: message.CallType,
                camId: currentCamId,
                phoneNumber: message.PhoneNumber ? message.PhoneNumber : that.phoneNumber,
                frame: currentFrame ? currentFrame.frame : 0,
                currentState: "Wrapup",
                action: "state"
            }
            that.svrEvents.onChangeStatus(newMessageWrapup);
        }else{
            that.svrEvents.onChangeStatus(message);
        }
        
    },

    "ERROR": function (message, that) {
        triggerNotifications(that, message.Code, MESSAGE_TYPE.ERROR, MESSAGE_FROM.CW, 'Centerware is already open');
    },
    "Problem": function (message, that) {
        triggerNotifications(that, MESSAGE_CODE.LOGIN[10002], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
        that.svrEvents.onChangeStatus(message);
        that.sharedData.isProblemStatus = true;
    },
    "Assisted": function (message, that) {
        console.info("[AgentSDK] [Info]: Starting assisted time.");
        that.svrEvents.onChangeStatus(message);
        that.sharedData.setCurrentState(message.currentState);
    },
}

const delay = ms => new Promise(res => setTimeout(res, ms));

const timeWrapup = async(that, time) => {
    const unwantedStates = [LIST_STATES.DIALOG, LIST_STATES.NOTREADY, LIST_STATES.ASSISTED, LIST_STATES.PROBLEM];
    await delay(time * 1000);
    if(typeof that.sharedData.currentState === 'string' && !unwantedStates.includes(that.sharedData.currentState)){
        if(that.sharedData.isAssistedMode){
            that.sharedData.setCurrentState(LIST_STATES.ASSISTED);
        } else {
            that.setReady();
        }
    }
}
